module.exports = __webpack_public_path__ + "static/img/3.b89b4209.png";